<template>
  <detail-card :data="invoice"
               type="invoice"
               v-if="invoice"
               v-bind="$attrs">
    <template v-slot:header>
      {{ invoice.number }}
    </template>
    <template v-slot:body>
      <prop name="vom">{{ invoice.createdTime | dateTime }}</prop>
      <prop name="Nummer">{{ invoice.externalNumber }}</prop>
      <prop name="Status">
        <invoice-state-badge :invoice="invoice"/>
      </prop>
      <prop name="Betrag">{{ invoice.amount | price }}</prop>
      <prop name="USt.">{{ invoice.vat | price }}</prop>
      <prop name="Transaktion" v-if="transaction">
        <a :href="`https://www.paypal.com/unifiedtransactions/details/payment/${transaction.transactionCode}`" target="_trans">{{ transaction.transactionCode}}</a>
      </prop>
      <prop name="versendet">
        <bool :value="invoice.sent"/>
      </prop>
      <prop name="Dokument" style="display: none;">
        <invoice-document-link :id="invoice.id">Rechnungsdokument</invoice-document-link>
      </prop>
      <ref type="order" :id="invoice.order.id">{{ invoice.order.number }}</ref>
    </template>
  </detail-card>
</template>

<script>

import DetailCard from "@/layouts/DetailCard";
import Prop from "@/layouts/Prop";
import Bool from "@/layouts/Bool";
import Ref from "@/layouts/Ref";
import InvoiceDocumentLink from "@/components/invoice/InvoiceDocumentLink";
import {invoiceState} from "../../utils/invoice-utils";
import InvoiceStateBadge from "./InvoiceStateBadge.vue";

export default {
  components: {InvoiceStateBadge, InvoiceDocumentLink, Bool, Prop, DetailCard, Ref},
  props: {
    invoice: Object,
  },
  data() {
    return {
      i: null,
      transaction: null,
      states: ['open', 'pending', 'paid', 'canceled', 'credited'].map(s => invoiceState(s))
    }
  },
  watch: {
    invoice: {
      immediate: true,
      handler(invoice) {
        if (invoice) {
          this.$api.get(`/accounting/transactions`, {
            params: {
              invoice: invoice.number
            }
          })
              .then(res => this.transaction = res.data)
              .catch(err => this.handleError(err))
        }
      }
    }
  }
}
</script>
